import { useAuth } from '@/contexts/Auth';
import { Button } from '@ygoargentina/ui/components/custom/button';
import { FileQuestion } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

export default function NotFoundError() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    // eslint-disable-next-line react-hooks/immutability -- intentional: see surrounding code
    window.location.href = '/login';

    return;
  }

  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <FileQuestion className="h-20 w-20 text-muted-foreground mb-2" />
        <h1 className="text-[7rem] leading-tight font-bold">404</h1>
        <span className="font-medium text-lg">
          Ups, no encontramos esta pagina
        </span>
        <p className="text-muted-foreground text-center">
          Parece que la pagina que buscas no existe <br />o fue movida a otra
          ubicacion.
        </p>
        <div className="mt-6 flex gap-4">
          <Button variant="outline" onClick={() => window.history.back()}>
            Volver atras
          </Button>
          <Button onClick={() => navigate({ to: '/' })}>Ir al inicio</Button>
        </div>
      </div>
    </div>
  );
}
